class MattressCollection {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.swiperEl = this.wrapper.querySelector('.swiper');

		if (typeof Swiper === 'undefined') return;
    if (!this.swiperEl || this.swiperEl.swiper) return;

    this.navBtns = this.wrapper.querySelectorAll('.mattress-collection__nav-item');

    this.init();
  }

  init() {
    this.bindEvents();
    this.handleResize();
  }
  
  bindEvents() {
    window.addEventListener('resize', () => {
      this.handleResize();
    });

    this.navBtns.forEach((btn, index) => {
      btn.addEventListener('click', (e) => {
        // this.setActiveNav(index);
        
        if (this.swiper) {
          this.swiper.slideToLoop(index);
        }
      });
    })
  }
  
  handleResize() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;
    
    if (isMobile) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }
  
  initSwiper() {
    if (this.swiper) return;
    
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      speed: 700,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      effect: 'coverflow',
      coverflowEffect: {
        depth: 150,
        rotate: 0,
        scale: 1,
        stretch: 0,
        slideShadows: false
      },
      on: {
        slideChange: (swiper) => {
          this.setActiveNav(swiper.realIndex);
        }
      }
    });
  }
  
  destroySwiper() {
    if (!this.swiper) return;
    
    this.swiper.destroy(true, true);
    this.swiper = null;
  }

  setActiveNav(index) {
    this.navBtns.forEach((btn) => {
      btn.classList.remove('active');
    });
    
    this.navBtns[index]?.classList.add('active');
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.mattress-collection').forEach(wrapper => {
    new MattressCollection(wrapper);
  });
});